import {
  SUPPLIER_PRODUCT_LIST,
  SUPPLIER_PRODUCT_LIST_SUCCESS,
  SUPPLIER_PRODUCT_LIST_FAILURE,
  SUPPLIER_PRODUCT_DATA,
  SUPPLIER_PRODUCT_DATA_SUCCESS,
  SUPPLIER_PRODUCT_DATA_FAILURE,
  SUPPLIER_PRODUCT_SEARCH,
  SUPPLIER_PRODUCT_SEARCH_SUCCESS,
  SUPPLIER_PRODUCT_SEARCH_FAILURE,
  SUPPLIER_PRODUCT_CREATE,
  SUPPLIER_PRODUCT_CREATE_SUCCESS,
  SUPPLIER_PRODUCT_CREATE_FAILURE,
  SUPPLIER_PRODUCT_UPDATE,
  SUPPLIER_PRODUCT_UPDATE_SUCCESS,
  SUPPLIER_PRODUCT_UPDATE_FAILURE,
  SUPPLIER_PRODUCT_DELETE,
  SUPPLIER_PRODUCT_DELETE_SUCCESS,
  SUPPLIER_PRODUCT_DELETE_FAILURE,
} from "./actionType";

//SUPPLIER_PRODUCT_LIST
export const supplierProductList = () => {
  return {
    type: SUPPLIER_PRODUCT_LIST,
  };
};
export const supplierProductListSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_LIST_SUCCESS,
    payload: data,
  };
};
export const supplierProductListFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_LIST_FAILURE,
    payload: error,
  };
};
//SUPPLIER_PRODUCT_DATA
export const supplierProductData = (data) => {
  return {
    type: SUPPLIER_PRODUCT_DATA,
    payload: data,
  };
};
export const supplierProductDataSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_DATA_SUCCESS,
    payload: data,
  };
};
export const supplierProductDataFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_DATA_FAILURE,
    payload: error,
  };
};
//SUPPLIER_PRODUCT_SEARCH
export const supplierProductSearch = (data) => {
  return {
    type: SUPPLIER_PRODUCT_SEARCH,
    payload: data,
  };
};
export const supplierProductSearchSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_SEARCH_SUCCESS,
    payload: data,
  };
};
export const supplierProductSearchFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_SEARCH_FAILURE,
    payload: error,
  };
};
//SUPPLIER_PRODUCT_CREATE
export const supplierProductCreate = (data) => {
  return {
    type: SUPPLIER_PRODUCT_CREATE,
    payload: data,
  };
};
export const supplierProductCreateSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_CREATE_SUCCESS,
    payload: data,
  };
};
export const supplierProductCreateFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_CREATE_FAILURE,
    payload: error,
  };
};
//SUPPLIER_PRODUCT_UPDATE
export const supplierProductUpdate = (data) => {
  return {
    type: SUPPLIER_PRODUCT_UPDATE,
    payload: data,
  };
};
export const supplierProductUpdateSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_UPDATE_SUCCESS,
    payload: data,
  };
};
export const supplierProductUpdateFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_UPDATE_FAILURE,
    payload: error,
  };
};
//SUPPLIER_PRODUCT_DELETE
export const supplierProductDelete = (data) => {
  return {
    type: SUPPLIER_PRODUCT_DELETE,
    payload: data,
  };
};
export const supplierProductDeleteSuccess = (data) => {
  return {
    type: SUPPLIER_PRODUCT_DELETE_SUCCESS,
    payload: data,
  };
};
export const supplierProductDeleteFailure = (error) => {
  return {
    type: SUPPLIER_PRODUCT_DELETE_FAILURE,
    payload: error,
  };
};
